import { GoToAppDownloadBox } from '../../steps/GoToAppStep/GoToAppDownloadBox';
import { LogoWithName } from '../LogoWithName';
import { RootBox, Wrapper } from '../v2/BaseStepV2';
import { ColWithBackgroundImage } from '../v2/TwoSidedLayout/ColWithBackgroundImage';
import { TwoSidedLayout } from '../v2/TwoSidedLayout/TwoSidedLayout.style';
import {
  PaymentCompletedCirclesMember,
  PaymentCompletedCongratulations,
  PaymentCompletedContent,
  PaymentCompletedContentBoxWrapper,
  PaymentCompletedLeftCol,
  PaymentCompletedLogoWrapper,
  PaymentCompletedTitle,
} from './PaymentCompleted.style';
import { PaymentCompletedtepBenefits } from './PaymentCompletedBenefits';

export const PaymentCompleted = () => {
  const benefits = [
    'Daily expert guidance',
    'Personal support chats',
    'Access all the forums',
    'Exclusive masterclasses',
    'Peer-led support rooms',
  ];

  const urls = {
    backgroundImageUrl:
      'https://res.cloudinary.com/better-with-us/image/upload/f_auto,q_auto/onboarding-v4/web_go_to_app_v2_step.webp',
    desktopLink: 'https://7chairs.hubspotpagebuilder.com/circles-app-download?voices-lobby=true',
    mobileLink: 'https://circlesup-support.onelink.me/Zfmp/d489pmm7',
    androidPlayStoreUrl: 'https://play.google.com/store/apps/details?id=com.sevenchairs',
    iosAppStoreUrl: 'https://circlesup-support.onelink.me/Zfmp/nc3cuvj7',
  };

  return (
    <RootBox addSpacingNeededForMobileButton={false}>
      <Wrapper>
        <TwoSidedLayout>
          <PaymentCompletedLeftCol>
            <PaymentCompletedContentBoxWrapper>
              <PaymentCompletedContent>
                <PaymentCompletedLogoWrapper>
                  <LogoWithName />
                </PaymentCompletedLogoWrapper>
                <PaymentCompletedTitle>
                  <PaymentCompletedCongratulations>Congratulations!</PaymentCompletedCongratulations> <br />
                  You're now <br /> a <PaymentCompletedCirclesMember>Circles member.</PaymentCompletedCirclesMember>
                </PaymentCompletedTitle>

                <GoToAppDownloadBox {...urls} />
                <PaymentCompletedtepBenefits benefits={benefits}></PaymentCompletedtepBenefits>
              </PaymentCompletedContent>
            </PaymentCompletedContentBoxWrapper>
          </PaymentCompletedLeftCol>
          <ColWithBackgroundImage img={urls.backgroundImageUrl}></ColWithBackgroundImage>
        </TwoSidedLayout>
      </Wrapper>
    </RootBox>
  );
};
